module.exports = __webpack_public_path__ + "static/2-4383848c3a932a8e89a9a0ed6996b3d6.jpg";